import React from 'react'
import { useFela } from 'react-fela'
import { pathspotPrimary, toastifyError, toastifySuccess, toastifyWarning } from '../../../../../webapp-lib/pathspot-react/styles/ts/colors'
import { alignItems } from '../../../../../webapp-lib/pathspot-react/fela/styles/css-properties'
import { Fela } from '../../../../../webapp-lib/pathspot-react'

const tableContainer = (args: any) => {
  return {
    display: 'inline-flex !important',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
    width: '100%',
    borderColor: toastifyError,
    borderStyle: 'solid',
    borderWidth: '0px',
  }
}
const PTable = (props: any) => {
  const { items, tableColumns } = props
  const { css } = useFela()
  return (
    <Fela.PContainer>
      <div className={css(tableContainer)}>{props.children}</div>
    </Fela.PContainer>
  )
}

export default PTable
